// @ts-generator-hash: 59ec24e0365f027e4e8e1b0402fdb3800746cb42bf5d3b527fd8aecfcc1de11d
// Generation date: 8/15/2025 7:45:17 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.PhaseStatus
export enum PhaseStatus {
  NOT_STARTED = 0,
  SETUP = 1,
  READY = 2,
  GRANTEE_PENDING = 10,
  GRANTEE_PENDING_REVISION = 11,
  PENDING = 30,
  APPROVED = 40,
  INACTIVE = 100,
}
